import { request } from "@/utils/request";
import BASE_URL from "@/common/url.js";
let BASEURL = BASE_URL.baseUrl;

// 获取常购清单
export const fileUpload = (data, header) => {
  debugger;
  return uni.uploadFile({
    url: BASEURL + "/product/public/fileUpload",
    filePath: data.file.path,
    header: {
      "Content-Type:": "multipart/form-data",
    },
  });
};

// 搜索联想
export const searchSuggestions = (params) => {
  return request({
    url: "/product/public/select/search",
    method: "GET",
    data: params,
  });
};
